module.exports = __webpack_public_path__ + "img/Artwork.f8c26c18.png";